import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiCardComponent } from '@nexus/frontend-shared-ui';

@Component({
  selector: 'wishlist-detail-guest-guide',
  imports: [UiCardComponent],
  templateUrl: './wishlist-detail-guest-guide.component.html',
  styleUrl: './wishlist-detail-guest-guide.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistDetailGuestGuideComponent {}
